/**
 * Fonte única da verdade para todas as rotas da aplicação.
 * Nunca usar strings de rota "soltas" nos componentes — sempre importar daqui.
 */
export const ROUTES = {
  splash: "/",
  login: "/entrar",
  register: "/cadastro",
  forgotPassword: "/recuperar-senha",

  home: "/inicio",
  matches: "/jogos",
  groups: "/grupos",
  ranking: "/ranking",
  profile: "/perfil",

  // Liga (hub central da aplicação — shell com abas Feed/Palpites/Estatísticas)
  league: (leagueId: string) => `/ligas/${leagueId}`,
  leagueFeed: (leagueId: string) => `/ligas/${leagueId}/feed`,
  leaguePredictions: (leagueId: string) => `/ligas/${leagueId}/palpites`,
  matchDetail: (leagueId: string, matchId: string) => `/ligas/${leagueId}/partidas/${matchId}`,
  bonusQuestionsAnswer: (leagueId: string) => `/ligas/${leagueId}/perguntas-bonus`,
  duels: (leagueId: string) => `/ligas/${leagueId}/duelos`,
  createDuel: (leagueId: string, matchId: string) => `/ligas/${leagueId}/duelos/novo/${matchId}`,
  leagueStatistics: (leagueId: string) => `/ligas/${leagueId}/estatisticas`,
  leagueRanking: (leagueId: string) => `/ligas/${leagueId}/ranking`,

  // Configurações da Liga (admin/moderador)
  leagueSettings: (leagueId: string) => `/ligas/${leagueId}/configuracoes`,
  leagueSettingsGeneral: (leagueId: string) => `/ligas/${leagueId}/configuracoes/geral`,
  leagueSettingsScoring: (leagueId: string) => `/ligas/${leagueId}/configuracoes/pontuacao`,
  leagueSettingsClubs: (leagueId: string) => `/ligas/${leagueId}/configuracoes/clubes`,
  leagueSettingsHistory: (leagueId: string) => `/ligas/${leagueId}/configuracoes/historico`,
  leagueSettingsParticipants: (leagueId: string) => `/ligas/${leagueId}/configuracoes/participantes`,
  leagueSettingsImportPoints: (leagueId: string) => `/ligas/${leagueId}/configuracoes/importar-pontos`,
  leagueSettingsBonusQuestions: (leagueId: string) => `/ligas/${leagueId}/configuracoes/perguntas-bonus`,
  leagueSettingsRoundConfig: (leagueId: string) => `/ligas/${leagueId}/configuracoes/rodada`,

  // Criação de Liga (wizard)
  createLeague: "/ligas/criar",
  joinLeague: "/ligas/entrar",

  // Placeholders para módulos futuros (rotas já reservadas para não exigir
  // refatoração de navegação nas próximas etapas).
  groupDetail: (groupId: string) => `/grupos/${groupId}`,
  challenges: "/desafios",
  notifications: "/notificacoes",
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];
